import NeoNewsCard from "@/components/news-card";
import NeoAnalyse from "@/components/analyse";
import NeoLoader from "@/components/loader";
import OsintAxios from "@/axios/osint.js";
import toolsDisclaimer from "@/components/tools-disclaimer";

export default {
    name: "more-person-identifier",
    components: {NeoNewsCard, NeoAnalyse, NeoLoader, toolsDisclaimer},
    props: {
        content: {
            type: Object,
            default: () => {},
        },
        names: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            loading: false,
            personData: this.content,
        };
    },
    watch: {
        content: {
            handler: function(newValue) {
                this.personData = newValue;
            },
            deep: true,
        },
    },
    mounted() {},
    methods: {
        async fetch_more_data() {
            if (!this.personData.all_data) {
                this.loading = true;
                const {data} = await OsintAxios.post(
                    "/person-identifier/more",
                    {
                        search_pointer: this.personData["@search_pointer"],
                        name: this.names?.map((i) => ({
                            first_name: i.fNameInput,
                            middle_name: i.mNameInput,
                            last_name: i.lNameInput,
                            name_selected: i.fNameInput || i.mNameInput || i.lNameInput ? true : false,
                        })),
                    },
                    {
                        headers: {
                            "x-tool-name": this.$route.params.toolName,
                            "x-visited": true,
                        },
                    }
                );
                let pData = {};
                if (data?.data?.person) {
                    pData = data.data.person;
                    pData.all_data = true;
                    pData.expanded = true;
                    this.loading = false;
                    this.personData = pData;
                } else {
                    if (!data.status) {
                        this.$toast.error(data.message);
                    }
                    this.loading = false;
                    this.personData.allData = true;
                }
            }
        },
    },
};
